<template>
  <div class="col-12 col-md">
    <div
      class="border border-lightgray border-1 border-start-0 border-end-0 border-top-0"
    >
      <label v-if="label" :for="name" class="form-label">{{ label }}</label>
      <div class="input-group">
        <div v-if="icon" class="input-group-prepend">
          <span class="input-group-text"><i :class="icon"></i></span>
        </div>
        <select
          v-model="_value"
          :class="{ 'is-invalid': invalid }"
          :disabled="disabled"
          class="form-select form-select-sm border-0 text-secondary bg-light"
          aria-label="Default select example"
          @change="emit('change')"
        >
          <slot></slot>
        </select>
        <div class="invalid-feedback">{{ invalid }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseSelect",
};
</script>

<script setup>
import { computed, defineProps, defineEmits } from "vue";

const props = defineProps({
  name: {
    type: [String, Number],
    default: "",
  },
  icon: {
    type: String,
    required: false,
    default: "",
  },
  value: {
    type: [String, Number, Array],
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  invalid: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["update:value", "change"]);
const _value = computed({
  get() {
    return props.value;
  },
  set(val) {
    emit("update:value", val);
  },
});
</script>

<style scoped></style>
